<template>
  <div id="suppliers" class="px-4">
    <supplier-order-list />
  </div>
</template>
<script>
import SupplierOrderList from "@/components/supplier_management/SupplierOrderList.vue";
export default {
  components: {
    SupplierOrderList
  }
};
</script>
